import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex'

const CartModule = {
  namespaced: true,
  state: () =>({
    loading: false,
    cart: {},
    errors: [],
  }),
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setCart(state, cart) {
      state.cart = cart;
    },
    setErrors(state, errors) {
      state.errors = errors;
    }
  },
  actions: {
    getCart(context) {
      context.commit('setLoading', true);
      axios.get(route('cart.show')).then((response) => {
        this.loading = false;
        if (response.status === 200 && response.data && response.data.success) {
          context.commit('setCart', response.data.cart || {});
          context.commit('setLoading', false);
        }
      });
    },
    updateCart(context, item) {
      context.commit('setLoading', true);
      item = (({id, site_id, blog_id, link_id, page_id, category_id, title, url, image, description, follow, type, start_date, period, user_package_id, request_data }) => ({ id, site_id, blog_id, link_id, page_id, category_id, title, url, image, description, follow, type, start_date, period, user_package_id, request_data}))(item);

      if (!item.site_id) delete item.site_id;
      if (!item.blog_id) delete item.blog_id;

      axios
        .post(route('cart.update'), {
          ...item
        })
        .then((response) => {
          context.commit('setLoading', false);
          if (response.status == 200 && response.data) {
            context.commit('setErrors', response.data.errors);
            if (response.data.success) {
              context.commit('setCart', response.data.data || {});
            }
          }
        });
    },
    removeFromCart(context, id) {
      context.commit('setLoading', true);
      axios.delete(route('cart.remove', id)).then(() => {
        context.commit('setLoading', false);
        context.dispatch('getCart');
      });
    },
    removePromocode(context, id) {
      context.commit('setLoading', true);
      axios.delete(route('cart.removePromocode', id)).then(() => {
        context.commit('setLoading', false);
        context.dispatch('getCart');
      });
    }
  }
};

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    cart: CartModule
  }
})